import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { useNavigate, useParams } from "react-router-dom";
import {
  badgesListOfADepartmentAsync,
  selectBadgesListStatus,
  updateBadgeStatusByDepartmentAsync,
} from "../../home/cardsAndBadges/badges/badgesSlice";
import { SharedInterfaceBadges } from "../../home/cardsAndBadges/badges/sharedInterface";
import { BadgesList } from "../../home/cardsAndBadges/badges/badgesAPI";
import { BadgeSidePanel } from "../../home/cardsAndBadges/badges/sidePanel/BadgeSidePanel";

export const DepartmentBadges = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const department = useAppSelector(selectCurrentDepartment);
  const badgesListStatus = useAppSelector(selectBadgesListStatus);

  useEffect(() => {
    if (department && badgesListStatus === "idle") {
      void dispatch(badgesListOfADepartmentAsync(department.uuid));
    }
  }, [department, badgesListStatus, dispatch]);

  const sidePanelAction = useCallback(
    (props: Partial<BadgesList>) => {
      navigate(`/departments/cards/badges/${props.uuid}`);
    },
    [navigate],
  );

  const lockBadgeAction = useCallback(
    (isBadgeLocked: boolean, badgeUuid: string) => {
      void dispatch(
        updateBadgeStatusByDepartmentAsync({
          badgeUuid,
          status: isBadgeLocked ? "LOCKED" : "UNLOCKED",
        }),
      );
    },
    [dispatch],
  );

  if (params.tab !== "badges") {
    return;
  }

  return (
    <SharedInterfaceBadges
      sidePanelAction={sidePanelAction}
      sidePanel={<BadgeSidePanel lockBadgeAction={lockBadgeAction} />}
    />
  );
};
